import {select} from "../../store";
import {ADMISSION_PRELUDE_ROUTE} from "../../pages/page-admission-prelude/route";
import {createRouteGuard} from "../../routers/createRouteGuard";

export const UserHasAdmissionEntryToken = createRouteGuard({
  authenticatedSelector: select.admissionSession.hasAdmissionEntryToken,
  redirectPath: ADMISSION_PRELUDE_ROUTE,
});
